'use strict';

var _objectSpread = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/objectSpread");

var isIp = require('is-ip');

var defaults = {
  timeout: 5000
};
var urls = {
  v4: 'https://ipv4.icanhazip.com/',
  v6: 'https://ipv6.icanhazip.com/'
};

var queryHttps = function queryHttps(version, options) {
  var xhr;
  var promise = new Promise(function (resolve, reject) {
    var doReject = function doReject() {
      reject(new Error('Couldn\'t find your IP'));
    };

    xhr = new XMLHttpRequest();
    xhr.addEventListener('error', doReject, {
      once: true
    });
    xhr.addEventListener('timeout', doReject, {
      once: true
    });
    xhr.addEventListener('load', function () {
      var ip = xhr.responseText.trim();

      if (!ip || !isIp[version](ip)) {
        doReject();
      }

      resolve(ip);
    }, {
      once: true
    });
    xhr.open('GET', urls[version]);
    xhr.timeout = options.timeout;
    xhr.send();
  });

  promise.cancel = function () {
    xhr.abort();
  };

  return promise;
};

module.exports.v4 = function (options) {
  return queryHttps('v4', _objectSpread({}, defaults, options));
};

module.exports.v6 = function (options) {
  return queryHttps('v6', _objectSpread({}, defaults, options));
};